<template>
<div>
    <template v-if="action=='view'">
        <div class="table-settings mb-4" v-if="allData.count>0 || q!=''">
            <div class="row align-items-center justify-content-between">
                <div class="col col-md-6 col-lg-3 col-xl-4">
                   
                </div>
                <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">
                                    <router-link class="btn btn-success" :to="{name : 'index', params: { page: 'supersubcategory', action: 'add', id: id,  code: code }}"><span class="fa fa-edit mr-2"></span>Add Super SubCategory</router-link>

                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
            <div class="card-body" v-if="(allData.count>0)">
                <table class="table table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="allData.count>0">
                        <tr v-for="(data,key) in allData.subcategory" :key="key">
                            <td>
                                <a href="#" class="font-weight-bold">
                                    {{key+1}}
                                </a>
                            </td>
                            <td><span class="font-weight-normal">{{data.heading}}</span></td>
                            <td><span class="font-weight-normal">
                                    <img v-if="data.image!=''" :src="$root.URL_ROOT+'uploads/Category/'+data.photo" width="50">
                                </span></td>
                            <td><span class="font-weight-bold">
                                    <a class="btn btn-danger btn-xs" href="#" @click="update('mss_category',1,data.id);data.status=1" v-if="data.status==0"> Inactive</a>
                                    <a class="btn btn-success btn-xs" href="#" @click="update('mss_category',0,data.id);data.status=0" v-if="data.status==1"> Active</a>
                                </span></td>
                            <td>
                                <div class="btn-group">
                                    <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id , code: code  }}"><span class="fa fa-edit mr-2"></span>Edit</router-link>
                                    <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="5">No record found</td>
                        </tr>
                    </tbody>
                </table>
                <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination mb-0">
                            <template v-for="(paginate,key) in allData.links">
                                <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                    <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                </li>
                            </template>
                        </ul>
                    </nav>
                    <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
                </div>
            </div>
            <div class="card-body text-center" v-else>
                <div v-if="loading">
                    loading...
                </div>
                <div v-else>
                    <!-- <InlineSvg name="nouser"></InlineSvg> -->
                    <div>
                        <h3>Add and manage your {{page}}</h3>
                        <p>This is where you’ll add {{page}} and manage theme. You can also improve your website by adding.</p>
                        <router-link :to="{name : 'index', params: { page: page, action: 'add', id:0, code: code }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                        <br><br><br>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else-if="action=='add' || action=='edit'">
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information</h2>
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.heading" placeholder="Enter Page Heading" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label>Category Image</label>
                             <i>(Upload Image size max 1MB) </i>
                            <input class="form-control" type="file" id="file" ref="file" accept="image/*" />
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.lorder" placeholder="Page order"></MssInput>
                        </div>
                        <div class="col-md-6 mb-3 text-center" v-if="action=='edit'">
                            <img v-if="form.photo!=''" :src="$root.URL_ROOT+'uploads/Category/'+form.photo" style="float:right;margin:10px" width="100">
                        </div>
                    </div>
                     <div class="row align-items-center">
                        <div class="col-md-12 mb-3">
                            <div class="pull-right">
                                <MssInput type="switch" v-model="isEditor" :placeholder="isEditor ? 'Source Code' : 'View Editor'"></MssInput>
                            </div>
                            <label for="birthday">Page Body <span class="red-color">*</span></label>
                            <vue-editor v-if="isEditor" v-model="form.pbody" :editorToolbar="fullToolbar"></vue-editor>
                            <MssInput v-else type="textarea" v-model="form.pbody"></MssInput>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Visibility</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.is_featured" placeholder="Is Feature"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div>
                                <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import { VueEditor } from "vue2-editor";
// import $ from 'jquery'
import axios from 'axios'
export default {
    components: {
        VueEditor
    },
    props: [
        "page", "action", "id", "code" , "type"
    ],
    data() {
        return {
            isEditor: true,
            q: '',
            loading: false,
            allData: [],
            form: {
                id: null,
                lorder: 0,
                status: true,
                heading: '',
                photo: '',
                is_parent: 0,
                is_featured: true,
                type: 'supersubcategory_save',
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6, ]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: ''
        }
    },
    methods: {
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },

        addInit() {
            // this.getUnderof();
            this.reset()
        },
        editInit() {
            this.getDetail();
            // this.getUnderof();
        },
        viewInit() {
            this.allDatas(true)
        },
        reset() {
            this.form = {
                id: null,
                type: 'supersubcategory_save',
                lorder: 0,
                status: true,
                heading: '',
                file: '',
                is_parent: 0,
                is_featured: true
            };
        },
        // getUnderof() {
        //     var pList = [];
        //     pList.push({
        //         label: 'Parent',
        //         code: 0
        //     })
        //     axios({
        //         method: 'POST',
        //         url: this.$root.URL_ROOT + 'api.php?type=getCategory',
        //     }).then(function (response) {
        //         var data = response.data;
        //         $.each(data, function (key, param) {
        //             pList.push({
        //                 label: param.heading,
        //                 code: param.id
        //             })
        //         })
        //     })

        // },
        upload_file() {
            // var ev = this;
            this.file = this.$refs.file.files[0];

            // let formData = new FormData();
            // console.log(formData);
            // this.save_userimage();

        },
        // save_userimage: function () {
        //     var ev = this;
        //     this.file = this.$refs.file.files[0];

        //     let formData = new FormData();

        //     formData.append('photo', this.file);
        //     formData.append('id', this.id);

        //     if (this.file == undefined) {
        //         ev.$swal({
        //             message: "please upload image"
        //         });
        //     } else {
        //      if(this.action=='edit'){
        //         axios.post(this.$root.URL_ROOT + 'api.php?type=category_edit', formData, {
        //                 headers: {
        //                     'Content-Type': 'multipart/form-data'
        //                 }
        //             })
        //             .then(function (response) {
        //                 var data = response.data;
        //                 //console.log(data);
        //                 if (data.status == "success") {
        //                     ev.$swal({
        //                         title: data.msg,
        //                     });
        //                     // ev.getUserDetail();

        //                 } else {
        //                     ev.$swal({
        //                         title: data.msg,
        //         // text:data.msg
        //                     });
        //                 }
        //             })
        //     }
        //     }

        // },
        getDetail() {
            var ev = this
            var param = {
                id: this.id,
                type: 'getSingleCategory'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                ev.form = data.category
            })
        },
        allDatas() {
            var ev = this
             var product_code = 0
             var code = parseFloat(ev.code)
            if(code>0){
                product_code = parseFloat(ev.code)
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getSubCategory',
                    category_id: product_code
                }
            }).then(function (response) {
                var data = response.data;
                ev.allData = data
            })
        },
        submit() {
            var ev = this
            this.file = this.$refs.file.files[0];
            if (this.form.heading === '') {
                this.$toasted.global.error({
                    message: 'Please enter Heading '
                })
            } else if (this.file === '') {
                this.$toasted.global.error({
                    message: 'Please Select Image'
                })
            } else {
            var status = ''
                if(ev.form.status==true){
                status = 1
                }else{
                status = 0
                }
                let formData = new FormData();
                if (this.action == 'edit') {
                    formData.append('id', this.id);
                    this.form.type = 'supersubcategory_edit';
                }
                formData.append('lorder', this.form.lorder);
                formData.append('photo', this.file);
                formData.append('heading', this.form.heading);
                formData.append('pbody', this.form.pbody);
                formData.append('status', status);
                formData.append('is_parent', this.code);
                formData.append('is_featured', this.form.is_featured);
                formData.append('type', this.form.type);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    var data = response.data;
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                         ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                                action: 'view',
                                id: ev.code,
                                code: ev.code,
                            }
                        })
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);
                    }
                })
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_category',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        console.log('commonDelete', data)
                        self.allDatas()
                    })
                }
            })
        }
    },
    mounted() {
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
        'form.linkname': function (val) {
            var text = val.replace(' ', "")
            this.form.linkname = text
        },
        'loading': function (val) {
            if (val) {
                this.$swal.showLoading();
            } else {
                this.$swal.close()
            }
        },
        'q': function (newVal, oldVal) {
            if (newVal == '') {
                this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all';
            } else if (newVal != oldVal) {
                this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all/' + newVal;
            }
            this.allDatas(false);
        }
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
